import { Injectable } from '@angular/core';
import { Observable, map, catchError, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Attachment } from '@shared/entities/attachment';

@Injectable({
  providedIn: 'root'
})
export class FsAttachmentService {
  constructor(private http: HttpClient) {}

  registerAttachment(payload: { filePath: string; fileName: string; contentType?: string }): Observable<Attachment> {
    return this.http.post<Attachment>(`${environment.apiBaseUrl}/fs/attachments`, payload);
  }

  getAttachmentUrl(attachmentId: string): Observable<Blob> {
    return this.http.post(`${environment.apiBaseUrl}/fs/attachment`, { attachmentId }, { responseType: 'blob' }).pipe(
      map((blob: Blob) => {
        return blob;
      }),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  downloadFile(attachmentId?: string, filename?: string): Observable<void> {
    if (attachmentId === undefined || attachmentId === null) {
      throw new Error('Attachment ID is required for downloading the file.');
    }

    return this.getAttachmentUrl(attachmentId).pipe(
      map((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename || `attachment_${attachmentId}`;
        anchor.style.display = 'none';

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        window.URL.revokeObjectURL(url);
      })
    );
  }
}
